export default {
  toggleSLOShowDrafts: () =>
    <const>{
      type: 'TOGGLE_SLO_SHOWDRAFTS',
    },
  setSLOShowDrafts: (payload: boolean) =>
    <const>{
      type: 'SET_SLO_SHOWDRAFTS',
      payload,
    },
  toggleSLOHasBreachingOnly: () =>
    <const>{
      type: 'TOGGLE_SLO_HAS_BREACHING_ONLY',
    },
  setSLOHasBreachingOnly: (payload: boolean) =>
    <const>{
      type: 'SET_SLO_HAS_BREACHING_ONLY',
      payload,
    },
  toggleSLOHasQualityIssuesOnly: () =>
    <const>{
      type: 'TOGGLE_SLO_HAS_QUALITY_ISSUES_ONLY',
    },
  setSLOHasQualityIssuesOnly: (payload: boolean) =>
    <const>{
      type: 'SET_SLO_HAS_QUALITY_ISSUES_ONLY',
      payload,
    },
};
